import React, { useState } from "react";
import api from "../../api";
import {
  Paper,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  TableCell,
  IconButton,
} from "@material-ui/core";
import CreateIcon from "@material-ui/icons/Create";
import SearchIcon from "@material-ui/icons/Search";
import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmDialog from "../common/confirmDialog/ConfirmDialog";
import utils from "../../utils/utils";
import { PaymentMethodTypes } from "../../enums/enums";
import Pagination from "@material-ui/lab/Pagination";
import Tooltip from "@material-ui/core/Tooltip";
import PaymentMethodEdit from "./PaymentMethodEdit";
import PaymentMethodView from "./PaymentMethodView";

export default function PaymentMethodList({
  setIsLoading,
  setDataToast,
  dataTable,
  classes,
  paymentMethods,
  shortError,
  reloadData,
  paginationData,
}) {
  const itemsPerPage = 10;
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    id: undefined,
  });
  const [openEdit, setOpenEdit] = useState({ open: false });
  const [openView, setOpenView] = useState({ open: false });

  const preDeletePaymentMethod = (id) => {
    setDeleteDialog({ open: true, id: id });
  };

  const deletePaymentMethod = (id) => {
    setDeleteDialog({ ...deleteDialog, open: false });
    setIsLoading(true);
    api
      .deletePaymentMethod(id)
      .then((res) => {
        reloadData(1, 1, itemsPerPage, true);
        setIsLoading(false);
        utils.alertSuccess("Medio de Pago N° " + id, "Eliminado correctamente.");
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.response.data.errores) {
          utils.alertError("Medio de Pago N° " + id, err.response.data.errores[0]);
        } else {
          shortError("Ocurrió un error");
        }
      });
  };

  const changePage = (event, value) => {
    let from = (value - 1) * itemsPerPage + 1;
    let to = value * itemsPerPage;

    reloadData(value, from, to, false);
  };

  function RenderPaymentMethodType({ PaymentMethodType }) {
    let text = "";
    switch (PaymentMethodType) {
      case PaymentMethodTypes.CreditCard.Id:
        text = PaymentMethodTypes.CreditCard.Text;
        break;
      case PaymentMethodTypes.DebitCard.Id:
        text = PaymentMethodTypes.DebitCard.Text;
        break;
      case PaymentMethodTypes.CBU.Id:
        text = PaymentMethodTypes.CBU.Text;
        break;
      case PaymentMethodTypes.Cash.Id:
        text = PaymentMethodTypes.Cash.Text;
        break;
      case PaymentMethodTypes.BilledCash.Id:
        text = PaymentMethodTypes.BilledCash.Text;
        break;
    }

    return text;
  }

  return (
    <>
      {dataTable && dataTable.length > 0 && (
        <Paper className="c-mt-20 c-grid-results" elevation={3}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TableContainer>
                <Table className="c-table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell className="c-w-10">Forma de Pago</TableCell>
                      <TableCell className="c-w-20">Nombre</TableCell>
                      <TableCell className="c-w-10">Procesador de Pago</TableCell>
                      <TableCell className="c-w-20">Opciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataTable.map(({ id, name, paymentMethodType, paymentProcessorName }) => (
                      <TableRow key={id}>
                        <TableCell className="c-w-10">
                          <RenderPaymentMethodType PaymentMethodType={paymentMethodType} />
                        </TableCell>
                        <TableCell className="c-w-20">{name}</TableCell>
                        <TableCell className="c-w-10">{paymentProcessorName}</TableCell>
                        <TableCell className="c-w-20">
                          <Tooltip title="Ver" arrow>
                            <IconButton
                              className="c-grid-btn-info button-grid"
                              onClick={() => {
                                setOpenView({ open: true, id });
                              }}
                            >
                              <SearchIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Editar" arrow>
                            <IconButton
                              className="c-grid-btn-edit button-grid"
                              onClick={() => {
                                setOpenEdit({ open: true, id });
                              }}
                            >
                              <CreateIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Dar de baja" arrow>
                            <IconButton
                              className="c-grid-btn-cancel button-grid"
                              onClick={() => preDeletePaymentMethod(id)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12} container direction="column" alignItems="center" justify="center">
              <Pagination
                className="c-pagination"
                onChange={changePage}
                page={paginationData.currentPage}
                count={paginationData.count > 1 ? paginationData.count : 0}
                shape="rounded"
              />
            </Grid>
          </Grid>
        </Paper>
      )}
      {dataTable && dataTable.length === 0 && (
        <Paper className="c-mt-20" elevation={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} className="c-text-center">
              <h5>No se encontraron resultados.</h5>
            </Grid>
          </Grid>
        </Paper>
      )}
      {deleteDialog !== undefined && (
        <ConfirmDialog
          open={deleteDialog.open}
          message={"¿Desea eliminar el Medio de Pago N° " + deleteDialog.id + " ?"}
          cancelAction={() => setDeleteDialog(false)}
          confirmAction={() => deletePaymentMethod(deleteDialog.id)}
        />
      )}
      {openEdit.open && (
        <PaymentMethodEdit
          id={openEdit.id}
          classes={classes}
          setIsLoading={setIsLoading}
          setDataToast={setDataToast}
          setOpenEdit={setOpenEdit}
          openEdit={openEdit.open}
          shortError={shortError}
          paymentMethods={paymentMethods}
          reloadData={reloadData}
          itemsPerPage={itemsPerPage}
        />
      )}
      {openView.open && (
        <PaymentMethodView
          id={openView.id}
          classes={classes}
          setIsLoading={setIsLoading}
          setOpenView={setOpenView}
          openView={openView.open}
          shortError={shortError}
          paymentMethods={paymentMethods}
        />
      )}
    </>
  );
}
